import React from 'react';
import Breadcrumb from '../Breadcrumb';
import { BREADCRUMBS_MOBILE_HEIGHT, Container, InnerContainer } from './style';
import findIndex from 'lodash/findIndex';
import { Base } from 'styled';
import useScrollDirection, { ScrollDirection } from 'hooks/useScrollDirection';
import useTopNavPixelHeight from 'hooks/useTopNavPixelHeight';

export interface IBreadcrumbsProps {
  crumbConfig: Array<{
    label: string;
    ariaLabel: string;
    to: string;
    isActive: boolean;
    isHidden?: boolean;
  }>;
}

const Breadcrumbs = ({ crumbConfig }: IBreadcrumbsProps) => {
  const scrollDirection = useScrollDirection({
    initialDirection: ScrollDirection.SCROLL_UP,
  });

  const topNavHeight = useTopNavPixelHeight() || 0;

  const visibleCrumbs = crumbConfig.slice(
    0,
    findIndex(crumbConfig, (crumb) => crumb.isActive) + 1
  );

  if (!visibleCrumbs.length) {
    return null;
  }

  return (
    <Container
      as="ol"
      id="breadcrumbs"
      data-testid="breadcrumbs"
      $offset={
        scrollDirection == ScrollDirection.SCROLL_DOWN
          ? -(topNavHeight + BREADCRUMBS_MOBILE_HEIGHT)
          : topNavHeight
      }
    >
      <InnerContainer>
        <Base display="flex">
          {visibleCrumbs.map((crumb) => (
            <Breadcrumb
              key={crumb.to}
              to={crumb.to}
              label={crumb.label}
              ariaLabel={crumb.ariaLabel}
              showArrow={!crumb.isActive}
              disabled={crumb.isActive}
              isActive={crumb.isActive}
            />
          ))}
        </Base>
      </InnerContainer>
    </Container>
  );
};

export default Breadcrumbs;
